import styles from './sidebar-account-accordion.module.css';

import classNames from 'classnames';
import { UserClient } from '@/app/lib/schemas/types/shared';
import { Accordion } from 'radix-ui';
import {
  AccordionContent,
  AccordionTrigger
} from '@/app/ui/components/shared/accordion';
import { Avatar, Button, Flex, Separator, Text } from '@radix-ui/themes';
import { PERSONAL_SIDEBAR_ITEMS } from '@/app/lib/constants/navigation';
import { EnterIcon, ExitIcon, LightningBoltIcon } from '@radix-ui/react-icons';
import SidebarNavigationItemWithIcon from './sidebar-navigation-item-with-icon';

interface Props {
  user: UserClient | null;
  pathname: string;
  onClick: () => void;
  onLogin: () => void;
  onLogout: () => void;
  onSignUp: () => void;
}

const SidebarAccountAccordion = ({
  user,
  pathname,
  onClick,
  onLogin,
  onLogout,
  onSignUp
}: Props) => {
  return (
    <>
      {user ? (
        <Accordion.Item
          value='/profile'
          className={classNames(styles.Item, styles.AccountItem)}
        >
          <AccordionTrigger>
            <Flex
              gap='4'
              align='center'
            >
              <Avatar
                size='2'
                src={
                  user.preferences.showAvatar
                    ? user.personalData.avatar
                    : undefined
                }
                fallback={user.personalData.username.charAt(0)}
              />
              <Text>{user.personalData.username}</Text>
            </Flex>
          </AccordionTrigger>
          <AccordionContent>
            <ul className={styles.Sublist}>
              {PERSONAL_SIDEBAR_ITEMS.map(item => (
                <li
                  key={item.path}
                  className={
                    pathname.includes(item.path) ? styles.Active : undefined
                  }
                >
                  <SidebarNavigationItemWithIcon
                    item={item}
                    onClick={onClick}
                  />
                </li>
              ))}
              <Separator
                orientation='horizontal'
                my='3'
                size='4'
              />
              <li>
                <Button
                  variant='ghost'
                  className={styles.Button}
                  onClick={onLogout}
                >
                  <ExitIcon /> Выйти
                </Button>
              </li>
            </ul>
          </AccordionContent>
        </Accordion.Item>
      ) : (
        <Flex
          direction='column'
          justify='end'
        >
          <Accordion.Item
            value='subscribe'
            className={styles.AccountItem}
          >
            <Accordion.Header className={styles.Header}>
              <Accordion.Trigger
                className={classNames(styles.Trigger, styles.Login)}
                onClick={onSignUp}
              >
                <Flex gap='4'>
                  <LightningBoltIcon /> Оформить подписку
                </Flex>
              </Accordion.Trigger>
            </Accordion.Header>
          </Accordion.Item>
          <Accordion.Item
            value='login'
            className={classNames(styles.Item)}
          >
            <Accordion.Header className={styles.Header}>
              <Accordion.Trigger
                className={classNames(styles.Trigger, styles.Login)}
                onClick={onLogin}
              >
                <Flex gap='4'>
                  <EnterIcon /> Войти
                </Flex>
              </Accordion.Trigger>
            </Accordion.Header>
          </Accordion.Item>
        </Flex>
      )}
    </>
  );
};

export default SidebarAccountAccordion;
